import triggerService from '../service/trigger'
const state = {
    query: {
        macAddress: "",
        customer: "",
        type: "",
        version:"",
        page: 1,
        pageSize: 10,
    },
    loading: false,
    searchResult: {
        total: 0,
        triggers: [],
    },
}

const actions = {
    updateTrigger({ commit }, trigger) {
        return triggerService.updateTrigger(trigger).then(data => {
            commit('setTrigger', trigger);
            return data;
        })
    },
    newCertTrigger({ commit }, id) {
        commit('setLoading', true)
        return triggerService.newCertTrigger(id).then((cert) => {
            commit('setLoading', false)
            return cert;
        })
    },
    createTrigger({ commit }, trigger) {
        return triggerService.createTrigger(trigger).then(data => {
            trigger._id = data._id;
            commit('addTrigger', trigger);
            return data;
        })
    },
    deleteTrigger({ commit }, id) {
        return triggerService.deleteTrigger(id).then(() => {
            commit('removeTrigger', id);
            return id;
        })
    },
    getTriggers({ commit }, query) {
        commit('setLoading', true)
        return triggerService.getTriggers(query).then(triggers => {
            commit('setTriggers', triggers);
        }).catch(() => {
            commit('setLoading', false)
        })
    },

}
const mutations = {
    addTrigger(state, trigger) {
        state.searchResult.triggers.push(trigger)
    },
    removeTrigger(state, id) {
        var index = state.searchResult.triggers.findIndex(x => x._id == id)
        if (index) {
            state.searchResult.triggers.splice(index, 1)
        }
    },
    setTrigger(state, trigger) {
        let index = state.searchResult.triggers.findIndex(x => x._id == trigger._id)
        if (index != -1) {
            state.searchResult.triggers[index].customer = trigger.customer
        }
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setTriggers(state, triggers) {
        state.searchResult = triggers
        state.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



